import React, { useEffect } from "react";
import video from "../../static/video/bim.mp4";
import { getNextLevel } from "../../utils/builder/IModelsTree";
import "./loadingScreen.scss";
import { treeAdd } from "../../utils/helpers";
import { logError } from "../../utils/builder/IAmecLog";


const LoadingScreen = ({ setLoader, afterFunction = () => { } }) => {
    useEffect(() => {
        let i = 0;
        let endTime = 60;
        const interval = setInterval(() => {
            i = i + 1;
            if (i >= endTime) {
                afterFunction();
                return setLoader((prevState) => ({
                    ...prevState,
                    signinState: 2,
                }));
            }
            if (endTime == 60) {
                getNextLevel("#")
                    .then((res) => {
                        if (res.length > 0)
                            endTime = i + 10;
                    })
                    .catch((err) => {
                        logError("FrontEnd.src.screens.LoadingScreen.index.LoadingScreen.useEffect.setInterval", err.toString());
                        afterFunction();
                        setLoader((prevState) => ({
                            ...prevState,
                            signinState: 2,
                        }));
                    });
            }
        }, 1000);
        return () => clearInterval(interval);
    }, []);
    return (
        <div className="loading_screen">
            <div className="loading_screen_content">
                <h1>Performing first time setup</h1>
                <video autoPlay muted loop id="myVideo">
                    <source src={video} type="video/mp4" />
                </video>
            </div>
        </div>
    );
};

export default LoadingScreen;
